import { globalStores } from '.';
import { EPointType } from '../types';

export class PointStore {
  // 不能逐个修改点数据，需要整个set替换才行
  private _pointMap: Map<string, Set<number>>; // key: 墙体w或s-房间id，value: 对应点id集合

  constructor() {
    this._pointMap = new Map();
  }

  // ============================= 墙体点操作 =============================
  getWallPoint(key: number) {
    return this._pointMap.get(EPointType.Wall)?.has(key);
  }

  getWallPointIds() {
    return this._pointMap.get(EPointType.Wall) || new Set<number>();
  }

  refreshWallSet(newSet: Set<number>) {
    this._pointMap.set(EPointType.Wall, newSet);
  }

  removeWallPoint(key: string) {
    this._pointMap.delete(key);
  }

  clearWall() {
    this._pointMap.get(EPointType.Wall)?.clear();
  }

  // ============================= 隔墙点操作 =============================
  getRoomPoint(roomId: string, key: number) {
    return this._pointMap.get(`${EPointType.Sep}-${roomId}`)?.has(key);
  }

  getRoomPointIds(roomId: string) {
    return this._pointMap.get(`${EPointType.Sep}-${roomId}`) || new Set<number>();
  }

  refreshRoomSet(roomId: string, newSet: Set<number>) {
    this._pointMap.set(`${EPointType.Sep}-${roomId}`, newSet);
  }

  removeRoomPoint(roomId: string, key: number) {
    this._pointMap.get(`${EPointType.Sep}-${roomId}`)?.delete(key);
  }

  clearRoom(roomId: string) {
    this._pointMap.get(`${EPointType.Sep}-${roomId}`)?.clear();
  }

  // ============================= 其他操作 =============================
  // addPoint(data: IPointData) {
  //   // 墙体点：w，隔墙点：s-roomId
  //   const isRoomPoint = !!data.roomId;
  //   const typeKeyName = isRoomPoint ? `${EPointType.Sep}-${data.roomId}` : EPointType.Wall;
  //   if (!this._pointMap.has(typeKeyName)) {
  //     this._pointMap.set(typeKeyName, new Set());
  //   }

  //   this._pointMap.get(typeKeyName)!.add(data.id);
  // }

  refreshRoomPoints() {
    const roomSet = new Set(
      globalStores.roomStore.getRoomDatas().map((roomData) => `${EPointType.Sep}-${roomData.id}`)
    );
    this._pointMap.forEach((_, key) => {
      if (key.startsWith(EPointType.Wall)) return;

      if (roomSet.has(key)) return;

      this._pointMap.delete(key);
    });
  }

  clearAll() {
    this._pointMap.forEach((map) => map.clear());
    this._pointMap.clear();
  }

  // ============================= 方案保存相关 =============================
  getData() {
    // 浅拷贝一份
    return new Map(this._pointMap);
  }

  coverDatas(data: Map<string, Set<number>>) {
    this.clearAll();
    if (!data) return;

    this._pointMap = data;
  }
}
